module.exports = __webpack_public_path__ + "img/TreasuryOrgCardBackground.28d78d5c.svg";